import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";

/**
 * Calls the backend to auto-fix broken control-event links for a given event.
 * @param {string} eventId - The event document ID.
 * @param {string} prefix - API endpoint prefix.
 * @returns {Promise<{success: boolean, fixes: number, details: string[]}>}
 */
const fixControlLinksApi = async (eventId, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}database/event/${eventId}/fix-control-links`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `Failed to fix control links: ${response.status}`);
  }

  return await response.json();
};

export default fixControlLinksApi;
